import { render, staticRenderFns } from "./CraftingHighscoreComponent.vue?vue&type=template&id=7e5c9f05&"
import script from "./CraftingHighscoreComponent.vue?vue&type=script&lang=ts&"
export * from "./CraftingHighscoreComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CraftingHighscoreComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports